import React, { useEffect } from 'react';
import { ZdsSelect } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
export const Select = ({ field, onChange, value }) => {
    useEffect(() => {
        onChange(field, value || field.modifiedSettings[0].value);
    }, []);
    const handleChange = (e) => {
        onChange(field, e.target.value);
    };
    return (React.createElement(ZdsSelect, { required: field.mandatory, id: `powermail_field_${field.marker}`, onZdsChange: handleChange, value: value },
        React.createElement(Label, { field: field }),
        field.modifiedSettings.map((option, index) => (React.createElement("option", { key: `powermail_field_${field.marker}_${index}`, id: `powermail_field_${field.marker}_${index}`, value: option.value }, option.label)))));
};
